import { useState } from 'react';
import { Box, Typography, Collapse, Button } from '@mui/material';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';

export default function HomeIntro() {
  const [expanded, setExpanded] = useState(false); // Same default for bots and real users — no isHydrated/isSnapshotting guard needed, since this never branches on environment.

  return (
    <Box component="section" sx={{ maxWidth: 700, mx: 'auto', mt: 2, mb: 1, px: 2 }}>
      <Button
        size="small"
        onClick={() => setExpanded((prev) => !prev)}
        endIcon={
          <KeyboardArrowDownIcon
            sx={{
              transition: 'transform 0.2s',
              transform: expanded ? 'rotate(180deg)' : 'none',
            }}
          />
        }
        sx={{ textTransform: 'none', color: 'text.secondary' }}
      >
        What is The Quizzler?
      </Button>

      <Collapse in={expanded}>
        <Box sx={{ pt: 1.5, pb: 1 }}>
          <Typography
            component="h1"
            sx={{ fontSize: '1.05rem', fontWeight: 600, mb: 1 }}
          >
            700+ Harry Potter Trivia Questions, Free to Play
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, lineHeight: 1.7 }}>
            The Quizzler features over 700 Harry Potter trivia questions spanning
            all seven books and eight films, organized across five difficulty
            tiers from Easy to Impossible. Whether you're testing your memory of
            minor characters or diving deep into wand lore and Ministry politics,
            there's a question bank built for every level of fan.
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ mb: 1.5, lineHeight: 1.7 }}>
            Pick a difficulty, answer at your own pace, and see how you compare.
            Track your stats over time, join one of four rival teams, and climb
            the weekly leaderboard.
          </Typography>

          <Typography variant="body2" color="text.secondary" sx={{ lineHeight: 1.7 }}>
            Built by fans, for fans — The Quizzler started as a way to settle
            arguments about who really knows their Hogwarts trivia. Every
            question is original, written and reviewed by hand rather than
            scraped or auto-generated.
          </Typography>
        </Box>
      </Collapse>
    </Box>
  );
}